import React, {useMemo} from 'react';
import {connect} from "react-redux";
import {
  HIDE_MENU_WITH_NO_FEATURES,
  SIDEBAR_NAVIGATION_3D_BATHROOM_CABINET_BUTTONS,
  SIDEBAR_NAVIGATION_3D_CABINET_BUTTONS,
  SIDEBAR_NAVIGATION_BATHROOM_CABINET_BUTTONS,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS,
} from "../../../../constants";
import {FormattedMessage, injectIntl} from "react-intl";
import $ from "jquery";
import {addChangeValuePopup, setSQFTActiveButton, setSQFTMenuOpened} from "../../../../../../actions/sqftMenuFunctions";
import config from "../../../canvas/store/sqftConfig";
import {
  handleResetClick, handleResizeClick, handleRotateClick, handleSpacerClick, handleWallClick, is3DMode,
  resetEvents
} from "../../NavigationHelper";
import useFetchFeatures from "../../../../hocs/useFetchFeatures";
import LoadingSpinner from "../../../../../ui/loadingSpinner";
import {getIsBathroom} from "../../../../../kvComponent/navigation/countertopSwitchers";
import {getCurrentLayout} from "../../../../../appLayout";
import {getFeatureGroupName} from "../../../../../../misc/helpers";

const SqftToolMenuCabinet = (props) => {
  // other popups, modals and so on
  const { activeButton, menuOpened, setSQFTActiveButton, setSQFTMenuOpened, fabricatorData, intl } = props;
  // const buttonRefs = useRef({});

  let buttons = getIsBathroom()
    ? is3DMode()
      ? { ...SIDEBAR_NAVIGATION_3D_BATHROOM_CABINET_BUTTONS }
      : { ...SIDEBAR_NAVIGATION_BATHROOM_CABINET_BUTTONS }
    : is3DMode()
      ? { ...SIDEBAR_NAVIGATION_3D_CABINET_BUTTONS }
      : { ...SIDEBAR_NAVIGATION_CABINET_BUTTONS };

  const expanded = activeButton
    && menuOpened !== "bumpout"
    && (menuOpened === "move" || Object.keys(buttons).some(buttonKey => menuOpened === buttonKey));

  //this part ids used to remove buttons if there are no features
  const partIds = useMemo(() => HIDE_MENU_WITH_NO_FEATURES, []);
  const { featuresData, isLoading } = useFetchFeatures(partIds);

  // remove buttons without features
  if (!isLoading && featuresData) {
    buttons = Object.keys(buttons).reduce((newButtons, buttonKey) => {
      // remove hinge
      if (!(featuresData.hinge && featuresData.hinge.rows.length > 0)
        && buttonKey === SIDEBAR_NAVIGATION_CABINET_BUTTONS.hinge) {
        return newButtons;
      }

      // remove tall cabinet
      if (!(featuresData.tall_cabinet && featuresData.tall_cabinet.rows.length > 0)
        && (buttonKey === SIDEBAR_NAVIGATION_CABINET_BUTTONS.tall || buttonKey === SIDEBAR_NAVIGATION_3D_CABINET_BUTTONS.tall_cabinet)
      ) {
        if (!featuresData.tall_cabinet.rows.length) {
          console.log("features with 3d models wasn't found for the tall cabinets");
        }
        if (!featuresData.tall_cabinet.featureGroup) {
          console.log("featuregroup tall cabinets wasn't found");
        }

        return newButtons;
      }

      // remove end panel button
      if (
        !(featuresData.wall_door_end_accessory && featuresData.wall_door_end_accessory.rows.length > 0) &&
        !(featuresData.base_door && featuresData.base_door.rows.length > 0) &&
        !(featuresData.island_panel && featuresData.island_panel.rows.length > 0) &&
        !(featuresData.refridgerator_panel && featuresData.refridgerator_panel.rows.length > 0) &&
        buttonKey === SIDEBAR_NAVIGATION_CABINET_BUTTONS.end_panel
      ) {
        return newButtons;
      }

      newButtons[buttonKey] = buttons[buttonKey];

      return newButtons;
    }, {});
  }

  const handleButtonClick = (buttonKey) => {
    setSQFTMenuOpened(buttonKey);
    setSQFTActiveButton(buttonKey);
    config.workspace.menuItemActive = buttonKey;
    resetEvents();
    switch (buttonKey) {
      case SIDEBAR_NAVIGATION_CABINET_BUTTONS.move:
        setSQFTMenuOpened('');
        break;
      case SIDEBAR_NAVIGATION_CABINET_BUTTONS.resize:
        setSQFTMenuOpened('');
        setSQFTActiveButton(SIDEBAR_NAVIGATION_CABINET_BUTTONS.resize);
        handleResizeClick();
        break;
      case SIDEBAR_NAVIGATION_CABINET_BUTTONS.rotate:
        handleRotateClick();
        break;
      case SIDEBAR_NAVIGATION_CABINET_BUTTONS.spacer:
        setSQFTMenuOpened('');
        setSQFTActiveButton(SIDEBAR_NAVIGATION_CABINET_BUTTONS.spacer);
        handleSpacerClick();
        break;
      case SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall:
        setSQFTActiveButton(SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall);
        handleWallClick();
        break;
      case SIDEBAR_NAVIGATION_3D_CABINET_BUTTONS.top_cabinet:
      case SIDEBAR_NAVIGATION_3D_CABINET_BUTTONS.bottom_cabinet:
      case SIDEBAR_NAVIGATION_3D_CABINET_BUTTONS.tall_cabinet:
        setSQFTMenuOpened(buttonKey);
        break;
      case 'reset':
        handleResetClick();
        break;
    }

    $('.lightbox-option-selected').removeClass('lightbox-option-selected');
  };
  const getButtonName = (activeButton) => {
    const layout = getCurrentLayout();
    const buttonFeatureGroup = layout.getFeatureGroupByPartId(activeButton);
    if (buttonFeatureGroup) {
      return getFeatureGroupName(buttonFeatureGroup, intl, fabricatorData)
    }

    return <FormattedMessage id={"sqft.navigation.submenu." + activeButton}/>
  }

  return (
    <nav className={"navigation side" + (expanded ? " expanded" : "")} data-side="navigation">
      <div className="navigation-list">
        {isLoading
          ? <LoadingSpinner/>
          : !expanded ? null : Object.keys(buttons).map((buttonKey) => (
            <button key={buttonKey}
                    // ref={el => buttonRefs.current[buttonKey] = el}
                    className={"animated fadeInUp button button--" + buttonKey}
                    onClick={() => handleButtonClick(buttonKey)}>
              <span className="button-text">
                {getButtonName(buttonKey)}
              </span>
            </button>
          ))}
      </div>
    </nav>
  )
};

const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
  activeButton: store.sqftMenuState.activeButton,
  fabricatorData: store.fabricatorState,
});

const mapDispatchToProps = {
  setSQFTMenuOpened,
  setSQFTActiveButton,
  addChangeValuePopup,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftToolMenuCabinet)
);
